import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { useInjectReducer } from 'redux-injectors';

export interface AlgoliaState {
    searchKey: string;
}
export const initialState: AlgoliaState = {
    searchKey: '',
};

const slice = createSlice({
    name: 'algolia',
    initialState,
    reducers: {
        setSetSearchKey: (state, action: PayloadAction<string>) => {
            state.searchKey = action.payload;
        },
    },
});

export const { setSetSearchKey } = slice.actions;

export const useAlgolia = () => {
    useInjectReducer({ key: slice.name, reducer: slice.reducer });
    return { actions: slice.actions };
};
